import { createSlice } from '@reduxjs/toolkit';
import { chargeMethodList } from 'constants/lists';
import { deepCloneObject } from 'functions';

export const recursiveBillingSetupSlices = createSlice({
	name: 'recursiveBillingSetup',
	initialState: {},
	reducers: {
		// Get Billing Setup
		getBillingSetup_request: (state) => {
			state.getBillingSetup_requesting = true;
			state.getBillingSetup_isSuccessful = undefined;
		},
		getBillingSetup_success: (state, action) => {
			state.getBillingSetup_requesting = false;
			state.getBillingSetup_isSuccessful = true;
			
			state.billingSetup = action?.payload?.data.map((obj) => {
				let newObj = deepCloneObject(obj);
				newObj.ChargeMethod = obj?.ChargeMethod && obj?.ChargeMethod >= 0? chargeMethodList[obj?.ChargeMethod]?.label:"";
				return newObj;
			});
			state.billingSetupHeaders = action?.payload?.headers;
		},
		getBillingSetup_failure: (state) => {
			state.getBillingSetup_requesting = false;
			state.getBillingSetup_isSuccessful = false;
		},

		// Get Full Product Detail List
		getFullProductDetailList_request: (state) => {
			state.getFullProductDetailList_requesting = true;
			state.getFullProductDetailList_isSuccessful = undefined;
		},
		getFullProductDetailList_success: (state, action) => {
			state.getFullProductDetailList_requesting = false;
			state.getFullProductDetailList_isSuccessful = true;
			
			state.fullProductDetailList = action.payload;
		},
		getFullProductDetailList_failure: (state) => {
			state.getFullProductDetailList_requesting = false;
			state.getFullProductDetailList_isSuccessful = false;
		},

		// Get Full Product Detail
		getFullProductDetail_request: (state) => {
			state.getFullProductDetail_requesting = true;
			state.getFullProductDetail_isSuccessful = undefined;
		},
		getFullProductDetail_success: (state, action) => {
			state.getFullProductDetail_requesting = false;
			state.getFullProductDetail_isSuccessful = true;
			
			state.fullProductDetail = action.payload;
		},
		getFullProductDetail_failure: (state) => {
			state.getFullProductDetail_requesting = false;
			state.getFullProductDetail_isSuccessful = false;
		},

		// Get License Products
		getLicenseProducts_request: (state) => {
			state.getLicenseProducts_requesting = true;
			state.getLicenseProducts_isSuccessful = undefined;
		},
		getLicenseProducts_success: (state, action) => {
			state.getLicenseProducts_requesting = false;
			state.getLicenseProducts_isSuccessful = true;
			
			state.licenseProducts = action.payload;
		},
		getLicenseProducts_failure: (state) => {
			state.getLicenseProducts_requesting = false;
			state.getLicenseProducts_isSuccessful = false;
		},

		// Get Add Account
		addAccount_request: (state) => {
			state.addAccount_requesting = true;
			state.addAccount_isSuccessful = undefined;
			state.addAccount_errorMsg = undefined;
		},
		addAccount_success: (state, action) => {
			state.addAccount_requesting = false;
			state.addAccount_isSuccessful = true;
		},
		addAccount_failure: (state, action) => {
			state.addAccount_requesting = false;
			state.addAccount_isSuccessful = false;
			state.addAccount_errorMsg = action?.payload;
		},

		// Get Add Multi Account
		addMultiAccount_request: (state) => {
			state.addMultiAccount_requesting = true;
			state.addMultiAccount_isSuccessful = undefined;
			state.addMultiAccount_errorMsg = undefined;
		},
		addMultiAccount_success: (state, action) => {
			state.addMultiAccount_requesting = false;
			state.addMultiAccount_isSuccessful = true;
		},
		addMultiAccount_failure: (state, action) => {
			state.addMultiAccount_requesting = false;
			state.addMultiAccount_isSuccessful = false;
			state.addMultiAccount_errorMsg = action?.payload;
		},

		// Get Missing Products
		getMissingProducts_request: (state) => {
			state.getMissingProducts_requesting = true;
			state.getMissingProducts_isSuccessful = undefined;
		},
		getMissingProducts_success: (state, action) => {
			state.getMissingProducts_requesting = false;
			state.getMissingProducts_isSuccessful = true;
			
			state.missingProducts = action.payload;
		},
		getMissingProducts_failure: (state) => {
			state.getMissingProducts_requesting = false;
			state.getMissingProducts_isSuccessful = false;
		},
	},
});

export const { 
	getBillingSetup_request, getBillingSetup_success, getBillingSetup_failure,
	getFullProductDetailList_request, getFullProductDetailList_success, getFullProductDetailList_failure,
	getFullProductDetail_request, getFullProductDetail_success, getFullProductDetail_failure,
	getLicenseProducts_request, getLicenseProducts_success, getLicenseProducts_failure,

	addAccount_request, addAccount_success, addAccount_failure,
	addMultiAccount_request, addMultiAccount_success, addMultiAccount_failure,
	getMissingProducts_request, getMissingProducts_success, getMissingProducts_failure
} = recursiveBillingSetupSlices.actions;

export default recursiveBillingSetupSlices.reducer;